import React from 'react';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CancelIcon from '@material-ui/icons/Cancel';
import Typography from '../Typography';

const useStyles = makeStyles(theme => ({
  cancelIcon: {
    marginLeft: '5px',
    fontSize: '1em',
    color: theme.palette.facet.primaryGray,
  },
}));

const HideButton = ({ resource, onClick }) => {
  const classes = useStyles();
  return (
    <Button
      className={classes.deleteButton}
      onClick={onClick}
    >
      <Typography variant="caption">{resource.attr('ignored') === 'true' ? 'Unhide' : 'Hide'}</Typography>
      {resource.attr('ignored') !== 'true' && <CancelIcon size="small" className={classes.cancelIcon} />}
    </Button>
  );
};

HideButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  resource: PropTypes.object.isRequired,
};

export default HideButton;
